/* OPM quick-view — app-style bottom sheet for product cards.
   Port of the V1.5 concept's quick-view (pages/v1-5-mobile.jsx).
   Progressive enhancement: any element with [data-quickview] opens the sheet;
   without JS the element is a normal link to the product.
   Round 2 (Director): tap-to-zoom lives HERE (not the product page), plus
   favourites (localStorage) and quick-add-to-bag icon boxes with real SVGs. */
(function () {
  'use strict';

  var ICONS = {
    close: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 5l14 14M19 5L5 19"/></svg>',
    heart: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20.5C7 16.5 3.5 13.2 3.5 9.4 3.5 6.9 5.4 5 7.9 5c1.6 0 3.1.8 4.1 2.1C13 5.8 14.5 5 16.1 5c2.5 0 4.4 1.9 4.4 4.4 0 3.8-3.5 7.1-8.5 11.1z"/></svg>',
    heartFill: '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><path d="M12 20.5C7 16.5 3.5 13.2 3.5 9.4 3.5 6.9 5.4 5 7.9 5c1.6 0 3.1.8 4.1 2.1C13 5.8 14.5 5 16.1 5c2.5 0 4.4 1.9 4.4 4.4 0 3.8-3.5 7.1-8.5 11.1z"/></svg>',
    bag: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 8h14l-1.2 12.2a1.5 1.5 0 0 1-1.5 1.3H7.7a1.5 1.5 0 0 1-1.5-1.3z"/><path d="M8.5 10V6.5a3.5 3.5 0 0 1 7 0V10"/></svg>',
    zoom: '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="6.5"/><path d="M16 16l4.5 4.5M11 8.5v5M8.5 11h5"/></svg>'
  };

  function favList() {
    try { return JSON.parse(localStorage.getItem('opm-fav') || '[]'); } catch (e) { return []; }
  }
  function favHas(h) { return favList().some(function (x) { return x.h === h; }); }
  function favToggle(item) {
    var list = favList();
    if (favHas(item.h)) list = list.filter(function (x) { return x.h !== item.h; });
    else list.unshift(item);
    try { localStorage.setItem('opm-fav', JSON.stringify(list.slice(0, 40))); } catch (e) {}
    return favHas(item.h);
  }

  var sheet, backdrop, imgEl, titleEl, priceEl, linkEl, favBtn, bagBtn, vendorEl, current;

  function build() {
    if (sheet) return;
    backdrop = document.createElement('div');
    backdrop.className = 'qv-backdrop';
    backdrop.addEventListener('click', close);

    sheet = document.createElement('div');
    sheet.className = 'qv-sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.innerHTML =
      '<div class="qv-grab"></div>' +
      '<button class="qv-close" aria-label="Close quick view">' + ICONS.close + '</button>' +
      '<div class="qv-media"><img alt="" loading="eager"><span class="qv-zoomhint">' + ICONS.zoom + '</span></div>' +
      '<div class="qv-body">' +
      '  <div class="qv-vendor"></div>' +
      '  <div class="qv-title"></div>' +
      '  <div class="qv-price"></div>' +
      '  <div class="qv-sw-label" style="display:none"></div>' +
      '  <div class="qv-swatches"></div>' +
      '  <div class="qv-actions">' +
      '    <a class="btn btn--primary qv-link" href="#">View product &rarr;</a>' +
      '    <button class="qv-icobtn qv-fav" type="button" aria-label="Add to favourites">' + ICONS.heart + '</button>' +
      '    <button class="qv-icobtn qv-bag" type="button" aria-label="Add to bag">' + ICONS.bag + '</button>' +
      '  </div>' +
      '</div>';

    document.body.appendChild(backdrop);
    document.body.appendChild(sheet);

    imgEl = sheet.querySelector('.qv-media img');
    vendorEl = sheet.querySelector('.qv-vendor');
    titleEl = sheet.querySelector('.qv-title');
    priceEl = sheet.querySelector('.qv-price');
    linkEl = sheet.querySelector('.qv-link');
    favBtn = sheet.querySelector('.qv-fav');
    bagBtn = sheet.querySelector('.qv-bag');

    sheet.querySelector('.qv-close').addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    // pull down to close — drag anywhere while the sheet is scrolled to its top
    var startY = null, delta = 0;
    sheet.addEventListener('touchstart', function (e) {
      if (sheet.scrollTop > 2) return;
      startY = e.touches[0].clientY; delta = 0;
    }, { passive: true });
    sheet.addEventListener('touchmove', function (e) {
      if (startY === null) return;
      delta = e.touches[0].clientY - startY;
      if (delta > 0) {
        sheet.classList.add('qv-dragging');
        sheet.style.transform = 'translateY(' + delta + 'px)';
      }
    }, { passive: true });
    sheet.addEventListener('touchend', function () {
      sheet.classList.remove('qv-dragging');
      sheet.classList.add('qv-settle');
      if (delta > 110) { close(); }
      sheet.style.transform = '';
      setTimeout(function () { sheet.classList.remove('qv-settle'); }, 300);
      startY = null; delta = 0;
    });

    // tap the image to zoom in place
    sheet.querySelector('.qv-media').addEventListener('click', function () {
      sheet.classList.toggle('qv-zoomed');
    });

    favBtn.addEventListener('click', function () {
      if (!current) return;
      var on = favToggle({ h: current.handle, t: current.title, p: current.price, i: current.image });
      favBtn.innerHTML = on ? ICONS.heartFill : ICONS.heart;
      favBtn.classList.toggle('on', on);
    });

    bagBtn.addEventListener('click', function () {
      if (!current) return;
      if (current.hasopts === '1') { window.location.href = current.url; return; } // sizes/colours need the product page
      bagBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(current.vid, 10), quantity: 1 })
      }).then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function () {
          close();
          if (window.OPMCart) { OPMCart.open(); return; }
          // page-cart mode: no drawer to open — show the bag itself
          window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart';
        })
        .catch(function () { window.location.href = current.url; })
        .finally(function () { bagBtn.disabled = false; });
    });
  }

  function money(cents, sample) {
    var sym = (sample || '£').replace(/[\d.,\s].*$/, '') || '£';
    return sym + (cents / 100).toFixed(2);
  }

  function renderSwatches(product) {
    var wrap = sheet.querySelector('.qv-swatches');
    var label = sheet.querySelector('.qv-sw-label');
    wrap.innerHTML = ''; label.style.display = 'none';
    if (!product || !product.options || !product.variants) return;
    var names = product.options.map(function (o) { return (o.name || o).toString(); });
    var idx = names.findIndex(function (n) { return /colou?r|print|postcode|design/i.test(n); });
    if (idx === -1 && names.length === 1) idx = 0;
    if (idx === -1) return;
    var optName = names[idx];
    var seen = {};
    var values = [];
    product.variants.forEach(function (v) {
      var val = v.options[idx];
      if (seen[val]) return; seen[val] = true;
      values.push({ val: val, v: v });
    });
    if (values.length < 2) return;
    label.style.display = '';
    label.innerHTML = optName.toUpperCase() + ' · <b>' + values[0].val + '</b>';
    values.forEach(function (item, i) {
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'qv-sw' + (i === 0 ? ' on' : '');
      btn.setAttribute('aria-label', item.val);
      var vimg = (item.v.featured_image && item.v.featured_image.src) || product.featured_image || '';
      if (vimg) btn.innerHTML = '<img src="' + vimg.replace(/(\.[a-zA-Z]+)(\?|$)/, '_120x$1$2') + '" alt="">';
      btn.addEventListener('click', function () {
        wrap.querySelectorAll('.qv-sw').forEach(function (x) { x.classList.remove('on'); });
        btn.classList.add('on');
        label.innerHTML = optName.toUpperCase() + ' · <b>' + item.val + '</b>';
        // best variant for this value: first available, else first
        var match = product.variants.filter(function (v) { return v.options[idx] === item.val; });
        var pick = match.find(function (v) { return v.available; }) || match[0];
        if (pick) {
          current.vid = String(pick.id);
          priceEl.textContent = money(pick.price, current.price);
          if (pick.featured_image && pick.featured_image.src) imgEl.src = pick.featured_image.src;
          current.url = current.url.split('?')[0] + '?variant=' + pick.id;
          linkEl.href = current.url;
          // one-option products: the swatch fully resolves the variant — direct add is safe
          if (names.length === 1) current.hasopts = '0';
          bagBtn.disabled = !pick.available;
        }
      });
      wrap.appendChild(btn);
    });
  }

  function open(card) {
    build();
    current = {
      handle: card.dataset.handle || '', title: card.dataset.title || '',
      price: card.dataset.price || '', image: card.dataset.image || '',
      url: card.dataset.url || card.getAttribute('href') || '#',
      vid: card.dataset.vid || '', hasopts: card.dataset.hasopts || '0'
    };
    imgEl.src = current.image;
    imgEl.alt = current.title;
    titleEl.textContent = current.title;
    vendorEl.textContent = card.dataset.vendor || '';
    priceEl.textContent = current.price;
    linkEl.href = current.url;
    var on = favHas(current.handle);
    favBtn.innerHTML = on ? ICONS.heartFill : ICONS.heart;
    favBtn.classList.toggle('on', on);
    bagBtn.style.display = current.vid ? '' : 'none';
    sheet.classList.remove('qv-zoomed');
    sheet.querySelector('.qv-swatches').innerHTML = '';
    sheet.querySelector('.qv-sw-label').style.display = 'none';
    if (current.handle) {
      fetch('/products/' + current.handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (product) {
          if (product && product.vendor && !vendorEl.textContent) vendorEl.textContent = product.vendor;
          renderSwatches(product);
        })
        .catch(function () {});
    }
    document.body.classList.add('qv-open');
    backdrop.style.display = 'block';
    sheet.style.display = 'block';
    sheet.focus && sheet.focus();
  }

  function close() {
    if (!sheet) return;
    document.body.classList.remove('qv-open');
    backdrop.style.display = 'none';
    sheet.style.display = 'none';
    sheet.classList.remove('qv-zoomed');
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('[data-quickview]');
    if (!card) return;
    e.preventDefault();
    open(card);
  });
})();
